import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { withStyles, Grid } from '@material-ui/core';
import { UserCard, FHEContainerScroll, FHEContainer, FHEContainerForm, FHEItemText, FHEDivider, FHETitle } from 'data/components';
import { Toastr } from 'data/common';
import { SvgSDM18HCL } from 'data/common/iconsvg';

import {
    getSDM18HCLDetails,
    refreshSDM18HCLStatus,
    switchSDM18HCLMaster,
    dissociateSDM18HCLUser,
    dissociateSDM18HCLUserAndSwitchMaster
} from '../../data/SDM18HCL/actions';

class SDM18HCLDetail extends PureComponent {
    static propTypes = {
        getSDM18HCLDetails: PropTypes.func.isRequired,
        dissociateSDM18HCLUser: PropTypes.func.isRequired,
        dissociateSDM18HCLUserAndSwitchMaster: PropTypes.func.isRequired,
        switchSDM18HCLMaster: PropTypes.func.isRequired,
        refreshSDM18HCLStatus: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        SDM18HCL: PropTypes.object,
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired
    };

    static defaultProps = {
        SDM18HCL: new Map()
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null,
            actionDisabled: false
        };
    }

    componentDidMount() {
        this.getSDM18HCLDetails();
    }

    getSDM18HCLDetails = () => {
        const { getSDM18HCLDetails, match } = this.props;

        this.setState({ loading: true, error: null });

        getSDM18HCLDetails(match.params.SDM18HCLId)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };

    switchSDM18HCLMaster = (SDM18HCLMac, userId) => {
        const { switchSDM18HCLMaster } = this.props;

        return switchSDM18HCLMaster(SDM18HCLMac, userId)
            .then(data => {
                Toastr.success(Translator.translate('generic.user.actions.switchSuccess'));
                return data;
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.switchError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSDM18HCLUser = (SDM18HCLMac, userId) => {
        const { dissociateSDM18HCLUser } = this.props;

        return dissociateSDM18HCLUser(SDM18HCLMac, userId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    dissociateSDM18HCLUserAndSwitchMaster = (SDM18HCLMac, userId, masterId) => {
        const { dissociateSDM18HCLUserAndSwitchMaster } = this.props;

        return dissociateSDM18HCLUserAndSwitchMaster(SDM18HCLMac, userId, masterId)
            .then(() => {
                Toastr.success(Translator.translate('generic.user.actions.removeSuccess'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.user.actions.removeError')
                );
                throw err;
            })
            .finally(() => {
                this.setState({
                    actionDisabled: false
                });
            });
    };

    enableActions = () => {
        this.setState({
            actionDisabled: false
        });
    };

    disableActions = () => {
        this.setState({
            actionDisabled: true
        });
    };

    refreshStateSDM18HCL(SDM18HCLMac) {
        const { refreshSDM18HCLStatus } = this.props;
        return refreshSDM18HCLStatus(SDM18HCLMac)
            .then(() => {
                Toastr.success(Translator.translate('general.products.SDM18HCL.table.action.refresh.success'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('general.products.SDM18HCL.table.action.refresh.error')
                );
                throw err;
            });
    }

    renderUserList() {
        const { usersLoading, actionDisabled } = this.state;
        const { SDM18HCL, profile } = this.props;
        const users = [];

        if (!usersLoading && SDM18HCL.has('otherUsers')) {
            SDM18HCL.get('otherUsers').map(user => {
                const isMaster = SDM18HCL.get('userMasterId') === user.get('_id');
                let otherUsers = [];
                if (isMaster) {
                    SDM18HCL.get('otherUsers').map(user => {
                        if (user.get('_id') !== SDM18HCL.get('userMasterId'))
                            otherUsers.push({ id: user.get('_id'), label: `${user.get('firstname')} ${user.get('lastname')}` });
                    });
                }
                users.push(
                    <Grid key={user.get('_id')} container item sm={12} md={6} xl={4}>
                        <UserCard
                            isMaster={isMaster}
                            user={user}
                            profile={profile}
                            product={SDM18HCL}
                            productName="SDM18HCL"
                            environment="myfhe"
                            dissociateUserFunc={this.dissociateSDM18HCLUser}
                            dissociateUserAndSwitchMasterFunc={this.dissociateSDM18HCLUserAndSwitchMaster}
                            switchMasterFunc={this.switchSDM18HCLMaster}
                            actionDisabled={actionDisabled}
                            disableActions={this.disableActions}
                            enableActions={this.enableActions}
                            otherUsers={otherUsers}
                        />
                    </Grid>
                );
            });
            return (
                <Grid container spacing={3}>
                    {users}
                </Grid>
            );
        }
    }

    renderPartDetail = () => {
        const { SDM18HCL, classes } = this.props;
        return (
            <Grid container spacing={3}>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.operatingMode')}
                        itemContent={SDM18HCL.get('operatingMode') ? SDM18HCL.get('operatingMode').toUpperCase() : 'N/A'}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.relayState')}
                        itemContent={SDM18HCL.get('relayState')}
                        classContent={SDM18HCL.get('switchState') === 'ON' ? classes.connectedColor : classes.disconnectedColor}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText itemTitle={Translator.translate('general.table.column.remoteRef')} itemContent={SDM18HCL.get('remoteRef')} />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.climMode')}
                        itemContent={Translator.translate(`general.products.SDM18HCL.table.data.${SDM18HCL.get('climMode')}`)}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.climState')}
                        itemContent={SDM18HCL.get('climState')}
                        classContent={SDM18HCL.get('switchState') === 'ON' ? classes.connectedColor : classes.disconnectedColor}
                    />
                </Grid>
                <Grid container item sm={12} md={6} lg={4}>
                    <FHEItemText
                        itemTitle={Translator.translate('general.table.column.planningMode')}
                        itemContent={Translator.translate(`general.data.planningMode.${SDM18HCL.get('planningMode')}`)}
                    />
                </Grid>
            </Grid>
        );
    };

    renderChildren = () => {
        const { loading } = this.state;
        const { SDM18HCL, classes } = this.props;
        return (
            <Fragment>
                <FHETitle title={SDM18HCL.get('label')} Icon={SvgSDM18HCL} />
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.macAddress')}
                                    itemContent={
                                        SDM18HCL.get('macAddress')
                                            ? SDM18HCL.get('macAddress')
                                                  .match(/.{1,2}/g)
                                                  .join(':')
                                            : 'N/A'
                                    }
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    itemTitle={Translator.translate('general.table.column.firmwareVersion')}
                                    itemContent={SDM18HCL.get('firmwareVersion')}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText
                                    tooltip={Translator.translate('general.products.SDM18HCL.table.action.refresh.tooltip')}
                                    onClick={this.refreshStateSDM18HCL}
                                    itemTitle={Translator.translate('general.table.column.state')}
                                    itemContent={Translator.translate(`general.${SDM18HCL.get('state')}`)}
                                    classContent={SDM18HCL.get('state') === 'disconnected' ? classes.disconnectedColor : classes.connectedColor}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEItemText itemTitle={Translator.translate('general.table.column.email')} itemContent={SDM18HCL.get('userEmail')} />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    <FHEDivider title={Translator.translate('general.details')} />

                    <FHEContainerForm loading={loading} onRender={this.renderPartDetail} />

                    <FHEDivider title={Translator.translate('general.Users')} />
                    {this.renderUserList()}
                </FHEContainerScroll>
            </Fragment>
        );
    };
    render() {
        const { loading, error } = this.state;
        const { initialized } = this.props;
        return (
            <FHEContainer
                withBackIcon
                loading={loading && !initialized}
                error={error}
                onClickFunc={this.getSDM18HCLDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const users = state.environments.myfhe.data.Users.get('list');
    let SDM18HCL = state.environments.myfhe.data.SDM18HCL.getIn(['list', props.match.params.SDM18HCLId], new Map());
    if (SDM18HCL.get('usersList')) {
        let otherUsers = [];
        let masterUser = new Map();
        if (SDM18HCL.get('usersList')) {
            SDM18HCL.get('usersList').forEach(userId => {
                users.find(user => {
                    if (userId === user.get('_id')) {
                        if (masterUser.size === 0 && SDM18HCL.get('userMasterId') === user.get('_id')) {
                            masterUser = user;
                            otherUsers.unshift(user);
                        } else {
                            otherUsers.push(user);
                        }
                    }
                });
            });
            SDM18HCL = SDM18HCL.setIn(['userEmail'], masterUser.get('email')).setIn(['otherUsers'], otherUsers);
        }
    }
    return {
        profile: state.data.user,
        SDM18HCL,
        initialized: state.environments.myfhe.data.SDM18HCL.get('initialized')
    };
}

const styles = theme => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    },
    connectedColor: {
        color: theme.palette.success.main
    },
    disconnectedColor: {
        color: theme.palette.error.main
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch =>
            bindActionCreators(
                { getSDM18HCLDetails, refreshSDM18HCLStatus, switchSDM18HCLMaster, dissociateSDM18HCLUser, dissociateSDM18HCLUserAndSwitchMaster },
                dispatch
            )
    )(withStyles(styles, { withTheme: true })(SDM18HCLDetail))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/SDM18HCL/details.js